<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-card>
    <el-row>
      <el-col :span="24">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/RAP/myApproveListRAP' }">需求审批流程</el-breadcrumb-item>
          <el-breadcrumb-item>我发起的</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-divider></el-divider>
    <!-- 表格区域 -->
    <el-table :data="tableData" border stripe v-loading="loading" style="width: 100%">
      <el-table-column type="index"></el-table-column>
      <el-table-column label="标题" width="180">
        <template slot-scope="scope">
          <el-link @click="Dialog_box(scope.row)" type="primary">{{scope.row.Title}}</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="StepName" label="当前步骤" width="180"
      ></el-table-column>
      <el-table-column prop="ReceiveName" label="处理人"></el-table-column>
      <el-table-column prop="Status" label="审批状态">
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-tooltip content="查看" placement="top" :enterable="false">
            <el-button type="primary" icon="el-icon-view" circle size="mini" @click="Dialog_box(scope.row)"></el-button>
          </el-tooltip>
          <el-tooltip content="撤回" placement="top" :enterable="false">
            <el-button type="danger" icon="el-icon-refresh-left" circle size="mini" @click="recall(scope.row)" :disabled="scope.row.Status == '发起人撤销' ? true : false"></el-button>
          </el-tooltip>
          <el-dialog title="审批详情" :visible.sync="DialogVisible" width="70%" center >
            <div class="drawer_box">
              <el-steps :active="level" align-center >
                <el-step v-for="(item, index) in TimeLines" :key="index" :title="item.Name" :status="item.Result">
                  <template slot="description">
                    <div>{{item.CompletedTime}}</div>
                    <div>{{item.Handler}}</div>
                    <div>{{item.ResultMessage}}</div>
                  </template>
                </el-step>
              </el-steps>
              <div class="downloadBtn" >
                <el-button v-if="rowInfo.FangAnUrl == null ? false : true" size="mini" type="primary" @click="download_doc(rowInfo.FangAnUrl)" >下载方案<i class="el-icon-download "></i></el-button>
                <el-button v-if="rowInfo.Attachment == '' ? false : true" size="mini" type="primary" @click="download_doc(rowInfo.Attachment)" >下载附件<i class="el-icon-download "></i></el-button>
              </div>
              <div class="info_table">
                <el-row>
                  <el-col class="tableTitle" :span="6">编号</el-col>
                  <el-col class="tableTitle" :span="6">主题</el-col>
                  <el-col class="tableTitle" :span="6">需求类型</el-col>
                  <el-col class="tableTitle" :span="6">项目名称</el-col>
                </el-row>
                <el-row class="tableRow">
                  <el-col class="tableTd" :span="6">{{rowInfo.NeedNo}}</el-col>
                  <el-col class="tableTd" :span="6">{{ rowInfo.Theme }}</el-col>
                  <el-col class="tableTd" :span="6">{{ rowInfo.TypeName + ' / ' + rowInfo.CateName }}</el-col>
                  <el-col class="tableTd" :span="6">{{ rowInfo.ProjectName }}</el-col>
                </el-row>
                <el-row class="tableRow">
                  <el-col class="tableTitle" :span="6">需求部门名称</el-col>
                  <el-col class="tableTitle" :span="6">是否公司级需求</el-col>
                  <el-col class="tableTitle" :span="6">是否限制交付时间</el-col>
                  <el-col class="tableTitle" :span="6">预期交付日期</el-col>
                </el-row>
                <el-row class="tableRow">
                  <el-col class="tableTd" :span="6">{{rowInfo.DepartmentName}}</el-col>
                  <el-col class="tableTd" :span="6">{{ rowInfo.IsCompany == 1 ? '是' : '否' }}</el-col>
                  <el-col class="tableTd" :span="6">{{ rowInfo.IsLimitTime == 1 ? '是' : '否'}}</el-col>
                  <el-col class="tableTd" :span="6">{{ rowInfo.GiveDate == null ? '未设置' : rowInfo.GiveDate}}</el-col>
                </el-row>
                <div class="tableRowBox">
                  <div class="table_left">
                    <span>主要问题</span>
                  </div>
                  <div class="table_right">
                    {{ rowInfo.MainQuestion }}
                  </div>
                </div>
                <div class="tableRowBox">
                  <div class="table_left">
                    <span>使用范围</span>
                  </div>
                  <div class="table_right">
                    {{ rowInfo.UseRange }}
                  </div>
                </div>
                <div class="tableRowBox">
                  <div class="table_left">
                    <span>影响范围</span>
                  </div>
                  <div class="table_right">
                    {{ rowInfo.EffectRange }}
                  </div>
                </div>
                <div class="tableRowBox">
                  <div class="table_left" style="border-bottom:0px solid #000;">
                    <span>预期价值</span>
                  </div>
                  <div class="table_right">
                    {{ rowInfo.ExpectedValue }}
                  </div>
                </div>
              </div>
            </div>
          </el-dialog>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页区域 -->
    <el-pagination
      style="text-align:left;"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="TotalCount">
    </el-pagination>
    </el-card>
  </div>
</template>
<script>
import { GetNeedFlowMeList,GetUserCeate,GetNeedDtail,UpdateRAPStatus,GetStepTimeLine,Cancel } from "../../until/ZeusApiSDK/Logic/RAPLogic.js";
import { cryptoDecode } from "../../until/encrypt.js"

export default {
  data() {
    return {
      userInfo: {},
      keywords: "",
      tableData: [],
      total: 10,
      pageIndex: 1,
      pageSize: 10,
      currentPage: 1,
      DialogVisible: false,
      searchInstance: [],
      TotalCount: 0,
      TimeLines: [],
      level: 0,
      rowInfo: {},
      Material: {},
      loading : true
    };
  },
  methods: {
    //监听每页展示多少条数据改变事件
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetInformationId();
    },
    //监听当前页码改变事件
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GetInformationId();
    },
    //撤回审批
    async recall(row) {
      //流程撤回
      await Cancel(row.ID, row.FlowID, row.InstanceID, row.StepID).then(
        async res => {
          //当前状态修改为撤回
          await UpdateRAPStatus(row.InstanceID).then(res => {
            if (res.Result == 200) {
              this.$message({
                message: "撤回申请成功",
                type: "success"
              });
            } else {
              this.$message.error("撤回申请失败");
            }
          });
        }
      );
    },
    GetInformationId: async function() {
      await GetNeedFlowMeList(this.userInfo.userid).then(async res => {
        this.searchInstance = res.Data;
        var _this = this;
        await GetUserCeate(_this.userInfo.userid,_this.pageIndex,_this.pageSize,_this.searchInstance).then(async res => {
          this.TotalCount = res.TotalCount;
          res.DataList.forEach(e => {
            if (e.Status == 0) {
              e.Status = "待审批";
            } else if (e.Status == 1) {
              e.Status = "审批中";
            } else if (e.Status == 2) {
              e.Status = "已通过";
            } else if (e.Status == 3) {
              e.Status = "拒绝";
            } else if (e.Status == 4) {
              e.Status = "转交";
            } else if (e.Status == 5) {
              e.Status = "发起人撤销";
            }
          });
          this.tableData = res.DataList;
          this.loading = false;
        });
      });
    },
    
    async Dialog_box(row) {
      this.DialogVisible = true;
      await GetStepTimeLine(this.userInfo.userid, row.InstanceID).then(res => {
        res.TimeLines.forEach(e => {
          if (e.Result == '0') {
            e.Result = "wait";
          } else if (e.Result == 2) {
            e.Result = "finish";
          } else if (e.Result == 3) {
            e.Result = "error";
          } else if (e.Result == 4) {
            e.Result = "finish";
          } else if (e.Result == 5) {
            e.Result = "error";
          }
        });
        this.TimeLines = res.TimeLines;
        this.level = res.NowStep;
      });
      await GetNeedDtail(row.InstanceID).then(res => {
        this.rowInfo = res.Data;
      });
    },
    // 下载模板
    download_doc(file_path) {
      window.open(file_path);
    }
  },
  created() {
    var userinfo = JSON.parse(cryptoDecode(window.sessionStorage.getItem('userinfo')));
    this.userInfo.TrueName = userinfo.TrueName
    this.userInfo.userid = userinfo.UserId;
    this.GetInformationId();
  }
};
</script>
<style lang="less" scoped>
.el-table {
  margin-top: 15px;
}
.el-pagination {
  margin-top: 15px;
}
.el-drawer {
  padding: 0 15px !important;
}
.drawer_box {
  width: 100%;
}
.box_info {
  margin-top: 15px;
}
.text_right {
  text-align: right;
}
.text_left {
  text-align: left;
}
.item_height {
  height: 40px;
  line-height: 40px;
}

.info_table{
  margin-top: 4px;
  width: 100%;
  border: 1px solid #eee;
}
.tableRow,.tableRowBox{
  min-height: 38px;
}
.tableTitle{
  text-align: center;
  height: 38px;
  line-height: 38px;
  background-color: #FAFAFA;
  border-right: 1 solid #eee !important;
}
.tableTd{
  background-color: #FFF;
  text-align: center;
  line-height: 38px;
  border-right: 1 solid #eee !important;
}
.dividerRow{
  border-top: 1px solid #eee;
}
.tableRowBox{
  width: 100%;
  display: flex;
  box-sizing: border-box;
}
.table_left{
  position: relative;
  text-align: center;
  background-color: #FAFAFA;
  width: 25%;
  box-sizing: border-box;
  border-bottom: 1px solid #FFF;
}
.table_left span{
  position: absolute;
  top: 50%;
  left: 50%;
  transform : translateX(-50%) translateY(-50%);
  
}
.table_right{
  width: 75%;
  padding: 8px;
  box-sizing: border-box;
  border-top: 1px solid #FAFAFA;
}
.downloadBtn{
  display: flex;
  justify-content: flex-end;
}
</style>
